import { ele } from "cables-shared-client";
import api from "../../api.js";
import web from "../../index.js";

export default class PageNamespaceEdit
{
    updateNamespace(button, namespace)
    {
        web.buttons.startSavingAnimButton(button);
        const summaryEle = ele.byId("namespace-summary");
        const descriptionsEle = ele.byId("namespace-description");
        const visibilityEle = ele.byId("namespace-visibility");
        if (!summaryEle || !descriptionsEle) return;
        const data = { "summary": summaryEle.value, "description": descriptionsEle.value, "visibility": visibilityEle.value };
        api.post(
            "namespace/docs/" + namespace,
            data,
            () =>
            {
                web.buttons.stopSavingAnimButton(button);
                const searchParams = new URLSearchParams(window.location.search);
                if (searchParams.has("return"))
                {
                    document.location.href = searchParams.get("return");
                }
                else
                {
                    document.location.href = "/ops/" + namespace;
                }
            },
            (res) =>
            {
                web.buttons.stopSavingAnimButton(button, true, true);
                let msg = res.msg || JSON.stringify(res);
                console.log(msg);
            });
    }
}
